export type ParsedPersistedQueueFile = {
  queueKey: string;
  updatedAt: string;
  turns: unknown[];
};

export function parsePersistedQueueFromJson(raw: string): ParsedPersistedQueueFile | null {
  try {
    const o = JSON.parse(raw) as Record<string, unknown>;
    const queueKey =
      typeof o.queueKey === 'string'
        ? o.queueKey
        : typeof o.queueKeyHash === 'string'
          ? o.queueKeyHash
          : null;
    if (!queueKey || typeof o.updatedAt !== 'string' || !Array.isArray(o.turns)) return null;
    return { queueKey, updatedAt: o.updatedAt, turns: o.turns };
  } catch {
    return null;
  }
}
